import { Box } from "@mui/material";

import { useSubscriptionStatus } from "hooks";

import { LimitedBookingsCarrierRemainingBookingsText } from "../LimitedBookingsCarrierRemainingBookingsText";

export function PaidCarrierBanner() {
  const { subscription } = useSubscriptionStatus();
  return (
    <Box>
      {(subscription?.subscription_plan === "CARRIER_BRONZE" ||
        subscription?.subscription_plan === "CARRIER_SILVER" ||
        subscription?.subscription_plan === "CARRIER_GOLD" ||
        subscription?.subscription_plan === "CARRIER_PLATINUM") && (
        <LimitedBookingsCarrierRemainingBookingsText />
      )}
    </Box>
  );
}
